import * as React from 'react'
import { createRoot } from 'react-dom/client'
import { getValueFromCookie } from 'tsRoot/actions/cookie'
import graphqlQuery from 'tsRoot/actions/graphql'
import { projectApply } from 'tsRoot/actions/midworks-freelance/project'
import { getId, getParam, getMultiParams } from 'tsRoot/actions/url'

// import { paginationJsx } from 'tsRoot/components/pagination'

import { env } from 'tsRoot/constants'

interface urlQueryParams {
  page: string  | null,
  skillName?: string | null,
  skillId?: string | null,
  payMin?: string | null,
  feature?: string | null,
  workingDayMax?: string | null
  keywords?: string | null
  order?: 'updated_at' | 'pay_min' | null
  pref_id?: string | null; // 都道府県ID
  skills?: string[] | null, // スキルID
  occupations?: string[] | null, // 職種ID
  work_styles?: string[] | null // 働き方ID
  pay_min?: string | null,
  pay_max?: string | null,
}

async function getData(params: urlQueryParams) {
  let condition = ''
  condition = `page: ${params.page || 1}, limit: 25`
  condition = condition + `, order: "${params.order || 'updated_at'} DESC"` // updated_at | pay_min

  if(params.skillName) {
    let skillNames = '['
    params.skillName.split(',').forEach((name: string, idx: number) => {skillNames = skillNames + `${idx != 0 ? ',' : ''}"${name}"`})
    skillNames = skillNames + ']'
    condition = condition + `, skillNames: ${skillNames}`
  }

  if(params.skillId) condition = condition + `, skillIds: "${params.skillId}"`
  if(params.payMin) condition = condition + `, payMin: ${params.payMin}`
  if(params.feature) condition = condition + `, feature: "${params.feature}"`
  if(params.workingDayMax) condition = condition + `, workingDayMax: ${params.workingDayMax}`
  if(params.keywords) condition = condition + `, keywords: "${params.keywords}"`

  const query = `
  {
    projects(${condition}){
      count
      items{
        id
        hasUserApplied
      }
    }
  }
  `

  const res = await graphqlQuery(query)
  return res
}

async function getProjects(ids: number[]) {
  const query = `
  {
    projects(id: [${ids.join(',')}]) {
      items {
        id
        hasUserApplied
      }
    },
  }
  `

  const res = await graphqlQuery(query)
  return res
}

const projectApplicationJsx = (loginId: string, projectId: string | number, hasUserApplied: boolean, setState: React.Dispatch<React.SetStateAction<never[]>> ) => {
  if(loginId && loginId != 'false' && hasUserApplied) {
    // submit済み
    return <li><a className="p-jobSummaryBoard__button2 -done"><span>応募済み</span></a></li>
  } else if (loginId && loginId != 'false') {
    // ログイン済みでお気に入り登録をデータ登録する
    return <li onClick={() => {projectApply(projectId, setState)}} style={{cursor: 'pointer'}}><a className="p-jobSummaryBoard__button2 ga_register_projectslist"><span className="collect-tag-apply-project-list" siteobj-projectid={projectId}>応募する</span></a></li>
  } else {
    // 未ログインで会員登録に遷移させる
    if (projectId) {
      return <li style={{cursor: 'pointer'}}><a href={"/users/registration?project_id=" + projectId} className="p-jobSummaryBoard__button2 ga_register_projectslist"><span>応募する</span></a></li>
    }
    else {
      return <li style={{cursor: 'pointer'}}><a href="/users/registration" className="p-jobSummaryBoard__button2 ga_register_projectslist"><span>応募する</span></a></li>
    }
  }
}

const sortedProjectUrl = (params: urlQueryParams, sortKey: 'updated_at' | 'pay_min', firstPage?: boolean, withOutPage?: boolean) => {
  const query = new URLSearchParams()

  if(location.href.indexOf('/projects/skills/') != -1) {
    // /projects/skills以下の場合
    query.append('order', sortKey)
    return `${location.pathname}?${query.toString()}`
  } else {
    // /projectsの場合
    if(params.page && !withOutPage) query.append('page', firstPage ? '1' : params.page)
    if(params.skillName)     query.append('skill', params.skillName)
    if(params.payMin)        query.append('payMin', params.payMin)
    if(params.feature)       query.append('feature', params.feature)
    if(params.workingDayMax) query.append('workingDayMax', params.workingDayMax)
    if(params.keywords)      query.append('keywords', params.keywords)
    if(params.pay_min)        query.append('pay_min', params.pay_min)
    if(params.pay_max)        query.append('pay_max', params.pay_max)

    if (params.pref_id) query.append('pref_id', params.pref_id);
    params.skills?.forEach((skill) => query.append("skills[]", skill));
    params.occupations?.forEach((occupation) =>
      query.append("occupations[]", occupation)
    );
    params.work_styles?.forEach((workStyle) =>
      query.append("work_styles[]", workStyle)
    );

    query.append('order', sortKey)
    return `/projects?${query.toString()}`
  }
}

/*
const paginationParams = (params: urlQueryParams, sortKey: 'updated_at' | 'pay_min') => {
  const query = new URLSearchParams()

  query.append('order', sortKey)
  if(params.skillName)     query.append('skill', params.skillName)
  if(params.payMin)        query.append('payMin', params.payMin)
  if(params.feature)       query.append('feature', params.feature)
  if(params.workingDayMax) query.append('workingDayMax', params.workingDayMax)
  if(params.keywords)      query.append('keywords', params.keywords)

  return query.toString()
}
*/

const render = async(setState: React.Dispatch<React.SetStateAction<never[]>>) => {
  const loginId = getValueFromCookie(`midworks_mypage_${env}_login`)

  // クエリパラメータを取得
  const params = {
    page: getParam('page'),
    skillName: getParam('skill'), // /projects?skill=PHP といった指定で利用
    skillId: getId() == 'projects' ? '' : getId(), // /projects/skills/1  といった指定で利用
    payMin: getParam('payMin'),
    feature: getParam('feature'),
    workingDayMax: getParam('workingDayMax'),
    keywords: getParam('keywords'),
    order: getParam('order'),
    pref_id: getParam('pref_id'), // 都道府県ID
    skills: getMultiParams('skills'),
    occupations: getMultiParams('occupations'),
    work_styles: getMultiParams('work_styles'), // 働き方IDリスト（配列）
    pay_min: getParam('pay_min'),
    pay_max: getParam('pay_max'),
  } as urlQueryParams

  // 新着順
  const sortUpdatedElement = document.getElementById('projectSortUpdated')
  if(sortUpdatedElement && (params.order == 'updated_at' || params.order == null)) sortUpdatedElement.classList.add('-active')
  if(sortUpdatedElement) sortUpdatedElement.setAttribute('href', `${sortedProjectUrl(params, 'updated_at', true)}`)

  // 単価順
  const sortPayElement = document.getElementById('projectSortPay')
  if(sortPayElement && params.order == 'pay_min') sortPayElement.classList.add('-active')
  if(sortPayElement) sortPayElement.setAttribute('href', `${sortedProjectUrl(params, 'pay_min', true)}`)

  // 応募ボタン
  const projectDataElement = document.getElementById('projects-data')
  if (projectDataElement && projectDataElement.dataset.projects) {
    const projects = JSON.parse(projectDataElement.dataset.projects);
    const ids = projects.map((project: { id: number }) => project.id);
    const data = await getProjects(ids);
    data.projects.items.forEach((project: any) => {
      const applicationElement = document.getElementById(`application_button_${project.id}`)
      if(applicationElement) createRoot(applicationElement).render(projectApplicationJsx(loginId, project.id, project.hasUserApplied, setState))
    })
  }

}

/** エクスポートするJSXのコンポーネント */
export const Main = () => {
  const [applyId, setApplyId] = React.useState([]) // 案件応募を行った際のIDを格納して再 render を行う

  React.useEffect(() => {
    render(setApplyId)
  }, [applyId])
  // useEffectのReactDOMでviewの一部分だけ書き換えるようにreactを使っているため、ここではreturnを空で返す
  return (<></>);
}
